module.exports = __webpack_public_path__ + "img/Air-FranceKLM.582a4cb6.webp";